function displayProbability(probability: number): boolean {
  if (probability < 0 || probability > 100) {
    return true;
  }
  return Math.random() < probability / 100;
}

function getRandomPosition(availablePositions: number[], usedPositions: Set<number>): number | undefined {
  const filteredPositions = availablePositions.filter((pos) => !usedPositions.has(pos));
  if (filteredPositions.length === 0) {
    return undefined;
  }
  const index = Math.floor(Math.random() * filteredPositions.length);
  return filteredPositions[index];
}

export default function useShoutouts() {
  const isAuthenticated = useAuthState();
  const accountStore = useAccountStore();

  // displayProbability: 0-100 (in Percentage)
  // showIfLoggedIn: null (any), true (logged in only), false (logged out only)
  // positions: 0-9 (0: after first article, 1: after second article etc.)
  // showIfUserRoleNot: 'new-full-access' (hide for users with role 'new-full-access')
  // show: true (show shoutout), false (hide shoutout)

  const successStoryConfig = {
    name: 'success-story',
    displayProbability: 75,
    positions: [0, 1],
    showIfLoggedIn: null,
    showIfUserRoleNot: '%-%-%',
    show: true,
  };

  const registerNowConfig = {
    name: 'register-now',
    displayProbability: 75,
    positions: [3, 4, 5, 6],
    showIfLoggedIn: false,
    showIfUserRoleNot: '%-%-%',
    show: true,
  };

  const discountConfig = {
    name: 'discount',
    displayProbability: 75,
    positions: [1, 2, 3, 4, 8],
    showIfLoggedIn: null,
    showIfUserRoleNot: 'new-full-access',
    show: true,
  };

  const multiPortalConfig = {
    name: 'multi-portal',
    displayProbability: 100,
    positions: [1, 2, 3, 4, 5, 6],
    showIfLoggedIn: true,
    showIfUserRoleNot: '%-%-%',
    show: true,
  };

  const adjustSearchFilterConfig = {
    name: 'adjust-search-filter',
    displayProbability: 33,
    positions: [2,3,4,5,6],
    showIfLoggedIn: false,
    showIfUserRoleNot: '%-%-%',
    show: true,
  }


  const usedPositions = new Set<number>();

  const successStoryResult = ref(shouldShow(successStoryConfig));
  const successStoryPosition = ref(getRandomPosition(successStoryConfig.positions, usedPositions));
  if (successStoryResult.value && successStoryPosition.value !== undefined) {
    usedPositions.add(successStoryPosition.value);
  }

  const registerNowResult = ref(shouldShow(registerNowConfig));
  const registerNowPosition = ref(registerNowResult.value ? getRandomPosition(registerNowConfig.positions, usedPositions) : null);
  if (registerNowResult.value && registerNowPosition.value !== undefined && registerNowPosition.value !== null) {
    usedPositions.add(registerNowPosition.value);
  }

  const discountResult = ref(shouldShow(discountConfig));
  const discountPosition = ref(discountResult.value ? getRandomPosition(discountConfig.positions, usedPositions) : null);
  if (discountResult.value && discountPosition.value !== undefined && discountPosition.value !== null) {
    usedPositions.add(discountPosition.value);
  }

  const multiPortalResult = ref(shouldShow(multiPortalConfig));
  const multiPortalPosition = ref(multiPortalResult.value ? getRandomPosition(multiPortalConfig.positions, usedPositions) : null);
  if (multiPortalResult.value && multiPortalPosition.value !== undefined && multiPortalPosition.value !== null) {
    usedPositions.add(multiPortalPosition.value);
  }

    const adjustSearchFilterResult = ref(shouldShow(adjustSearchFilterConfig));
    const adjustSearchFilterPosition = ref(adjustSearchFilterResult.value ? getRandomPosition(adjustSearchFilterConfig.positions, usedPositions) : null);
    if (adjustSearchFilterResult.value && adjustSearchFilterPosition.value !== null) {
      usedPositions.add(adjustSearchFilterPosition.value);
    }

  function recalculateShoutOuts() {
    usedPositions.clear();

    successStoryResult.value = shouldShow(successStoryConfig);
    successStoryPosition.value = getRandomPosition(successStoryConfig.positions, usedPositions);
    if (successStoryResult.value && successStoryPosition.value !== undefined && successStoryPosition.value !== null) {
      usedPositions.add(successStoryPosition.value);
    }

    registerNowResult.value = shouldShow(registerNowConfig);
    registerNowPosition.value = registerNowResult.value ? getRandomPosition(registerNowConfig.positions, usedPositions) : null;
    if (registerNowResult.value && registerNowPosition.value !== undefined && registerNowPosition.value !== null) {
      usedPositions.add(registerNowPosition.value);
    }

    discountResult.value = shouldShow(discountConfig);
    discountPosition.value = discountResult.value ? getRandomPosition(discountConfig.positions, usedPositions) : null;
    if (discountResult.value && discountPosition.value !== undefined && discountPosition.value !== null) {
      usedPositions.add(discountPosition.value);
    }

    multiPortalResult.value = shouldShow(multiPortalConfig);
    multiPortalPosition.value = multiPortalResult.value ? getRandomPosition(multiPortalConfig.positions, usedPositions) : null;
    if (multiPortalResult.value && multiPortalPosition.value !== null) {
      usedPositions.add(multiPortalPosition.value);
    }

    adjustSearchFilterResult.value = shouldShow(adjustSearchFilterConfig);
    adjustSearchFilterPosition.value = adjustSearchFilterResult.value ? getRandomPosition(adjustSearchFilterConfig.positions, usedPositions) : null;
    if (adjustSearchFilterResult.value && adjustSearchFilterPosition.value !== null) {
      usedPositions.add(adjustSearchFilterPosition.value);
    }
  }

  function shouldShow(config: { displayProbability: number; showIfLoggedIn: boolean | null; showIfUserRoleNot?: string; show: boolean }): boolean {
    const displayBasedOnLogin =
      config.showIfLoggedIn === null || (config.showIfLoggedIn && isAuthenticated.value) || (!config.showIfLoggedIn && !isAuthenticated.value);
    const displayBasedOnRole = config.showIfUserRoleNot ? accountStore.user?.roleId !== config.showIfUserRoleNot : true;
    return config.show && displayBasedOnLogin && displayBasedOnRole && displayProbability(config.displayProbability);
  }

  return {
    successStoryResult,
    successStoryPosition,
    registerNowResult,
    registerNowPosition,
    discountResult,
    discountPosition,
    multiPortalResult,
    multiPortalPosition,
    adjustSearchFilterResult,
    adjustSearchFilterPosition,
    recalculateShoutOuts,
  };
}
